module.exports = __webpack_public_path__ + "img/cake.928a91e9.png";